import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import {
  withMobileDialog,
  Dialog,
  withStyles,
  DialogActions,
  DialogContent,
} from '@material-ui/core'
import { toggleTaskModal } from 'actions/campaign/addOrEdit'
import { toggleManagePhonesModal } from 'actions/tasks'
import ManagePhones from 'components/ManagePhones'
import Button from 'components/theme/Button'
import { toggleDialog } from 'actions/view'

export default withRouter(
  connect(
    state => ({
      managePhonesModalOpen: state.tasks.addOrEdit.managePhonesModalOpen,
      // taskModalOpen: state.campaign.addOrEdit.taskModalOpen,
    }),
    dispatch =>
      bindActionCreators(
        { toggleTaskModal, toggleManagePhonesModal, toggleDialog },
        dispatch,
      ),
  )(
    withStyles(theme => ({
      rounded: {
        borderRadius: 28,
        overflowY: 'hidden',
        height: '100%',
        [theme.breakpoints.down('sm')]: {
          borderRadius: 0,
          overflowY: 'auto',
        },
      },
    }))(
      withMobileDialog()(
        ({
          fullScreen, // toggleTaskModal,
          managePhonesModalOpen,
          classes,
          toggleManagePhonesModal,
          toggleDialog,
          history,
        }) => (
          <Dialog
            fullWidth
            maxWidth="xl"
            fullScreen={fullScreen}
            open={Boolean(managePhonesModalOpen)}
            onClose={() => toggleManagePhonesModal(false)}
            aria-labelledby="responsive-dialog-title"
            // disableBackdropClick
            // disableEscapeKeyDown
            PaperProps={{ classes: { rounded: classes.rounded } }}
          >
            <DialogContent>
              <ManagePhones />
            </DialogContent>
            <DialogActions>
              <Button
                onClick={() => {
                  history.push('/managecompliance')
                  toggleManagePhonesModal(false)
                }}
                color="primary"
              >
                Manage Compliance
              </Button>
              <Button
                onClick={() => {
                  toggleManagePhonesModal(false)
                }}
                color="primary"
              >
                Close
              </Button>
            </DialogActions>
          </Dialog>
        ),
      ),
    ),
  ),
)
